import React from "react";
import { LeaderboardMetric, MenuType } from "@/types/leader-board";
import UserLeaderBoardInfo from "./user-leader-board-info";
import { LeaderboardItemType } from "@/types/leader-board";
import ModalCard from "@/components/atomics/modal-card";
import StarBoostControl from "./star-boost-control";
import { useStarPayment } from "@/hooks/useStarPayment";

interface LeaderBoardBoostProps {
  className?: string;
  userInfo: LeaderboardItemType;
  selectedMenu: MenuType;
  metric: LeaderboardMetric;
  onClickClose: () => void;
  onRefetchData?: () => void;
}

export default function LeaderBoardRankBoost({
  className,
  userInfo,
  selectedMenu,
  metric,
  onClickClose,
  onRefetchData,
}: LeaderBoardBoostProps) {
  const { sendStars, isLoading } = useStarPayment({
    onSuccess: async () => {
      onRefetchData?.();
      setTimeout(() => {
        onClickClose();
      }, 1000);
    },
  });

  const getMenuLabel = () => {
    return selectedMenu === "collections" ? "collect." : selectedMenu;
  };

  const handleSendStar = async (starCount: number) => {
    await sendStars(userInfo.address, starCount);
  };

  return (
    <ModalCard title="rank boost" onClose={onClickClose} className={className}>
      <div className="flex flex-col px-[54px] py-[20px]">
        <span className="text-[24px] uppercase">{getMenuLabel()} boost</span>
      </div>

      <UserLeaderBoardInfo
        className=" !bg-[#2B2B2B]"
        circleColor="#2B2B2B"
        userInfo={userInfo}
        selectedMenu={selectedMenu}
        metric={metric}
      />

      <StarBoostControl onSend={handleSendStar} isLoading={isLoading} />
    </ModalCard>
  );
}
